import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";


const Logo = ({ mini, mode, sx }) => {
    return (
        <Div sx={{ display: "inline-flex", ...sx }}>
            <Link href={'/'}>
                {
                    !mini ?
                        <img src={mode === "light" ? `${ASSET_IMAGES}/logos/kurulsis.png` : `${ASSET_IMAGES}/logos/logo-white.png`} alt="KurulSİS" />

                        :
                        <img src={mode === "light" ? `${ASSET_IMAGES}/logos/kurulsis-short.png` : `${ASSET_IMAGES}/logos/logo-short-white.png`} alt="KurulSİS" />
                }
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
